import { useMemo } from "react";
import { useProgress } from "@/hooks/useProgress";
import { useSessions } from "@/hooks/useSessions";
import { useStreak } from "@/hooks/useStreak";
import type { AchievementStats } from "@/lib/achievement-card";

/** Los mismos números que muestra Mi Progreso: días, minutos y racha actual. */
export function useAchievementStats(userId: string | undefined): AchievementStats {
  const { completedDays, completedDates } = useProgress(userId);
  const { data: sessions = [] } = useSessions();
  const streak = useStreak(completedDates).current;

  const totalMinutes = useMemo(
    () =>
      sessions
        .filter((s) => completedDays.includes(s.day_number))
        .reduce((acc, s) => acc + (parseInt(s.duration) || 0), 0),
    [sessions, completedDays],
  );

  return { completedDays, totalMinutes, streak };
}
